import React, { useRef } from 'react';
import { FaLightbulb, FaUsers, FaChartLine, FaCommentDots } from 'react-icons/fa';
import './MissionSection.css';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { isIOS } from '../../hooks/isIos';

const FaLightbulbIcon = FaLightbulb as React.FC<React.SVGProps<SVGSVGElement>>;
const FaUsersIcon = FaUsers as React.FC<React.SVGProps<SVGSVGElement>>;
const FaChartLineIcon = FaChartLine as React.FC<React.SVGProps<SVGSVGElement>>;
const FaCommentDotsIcon = FaCommentDots as React.FC<React.SVGProps<SVGSVGElement>>;

export const MissionSection = () => {
	const ref = useRef(null);
	const marginValue = isIOS() ? '0px' : '-350px';
	const isInView = useInView(ref, { once: true, margin: marginValue });

	const stats = [
		{
			icon: <FaLightbulbIcon className='stat-icon' />,
			number: '1',
			label: 'Projekt',
			text: 'Unser erstes Startup-Projekt – mit Leidenschaft und Vision gestartet.',
		},
		{
			icon: <FaUsersIcon className='stat-icon' />,
			number: '5',
			label: 'Teammitglieder',
			text: 'Ein motiviertes Team aus Entwickler:innen, Designer:innen & Visionär:innen.',
		},
		{
			icon: <FaChartLineIcon className='stat-icon' />,
			number: '1000',
			label: 'Nutzerziel',
			text: 'Wir wollen bis Ende des Jahres 1000 aktive Nutzer:innen begeistern.',
		},
		{
			icon: <FaCommentDotsIcon className='stat-icon' />,
			number: '500',
			label: 'Feedbacks',
			text: 'Ziel: 500 ehrliche Rückmeldungen für ein besseres Erlebnis.',
		},
	];

	return (
		<section className='mission-section' ref={ref}>
			<motion.div
				initial={{ opacity: 0, y: 50 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ duration: 0.5, ease: 'easeOut' }}
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<h1 className='mission-title'>
					Unsere <span style={{ color: '#6C5CE7' }}>Mission</span>
				</h1>
				<p className='mission-description'>
					Bei <strong>Erledix</strong> wollen wir das Aufgabenmanagement für Familien und
					Wohngemeinschaften grundlegend verbessern. Unsere Werte: <em>Innovation</em>,{' '}
					<em>Zusammenarbeit</em>, <em>Benutzerfreundlichkeit</em> und{' '}
					<em>Transparenz</em>.
				</p>

				<div className='mission-stats'>
					{stats.map((stat, index) => (
						<motion.div
							className='stat-card'
							key={index}
							initial={{ opacity: 0, y: 30 }}
							animate={isInView ? { opacity: 1, y: 0 } : {}}
							transition={{ delay: index * 0.1, duration: 0.4 }}
						>
							{stat.icon}
							<h2 className='stat-number'>{stat.number}</h2>
							<p className='stat-label'>{stat.label}</p>
							<p className='stat-text'>{stat.text}</p>
						</motion.div>
					))}
				</div>

				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={isInView ? { opacity: 1, y: 0 } : {}}
					transition={{ delay: 0.6, duration: 0.4 }}
				>
					<Link to='/beta-signup' className='cta-button' style={{ marginTop: '1rem' }}>
						Gestalte mit uns die Zukunft von Erledix!
					</Link>
				</motion.div>
			</motion.div>
		</section>
	);
};
